import { InjectionToken } from "@angular/core";
import { FormFieldComponentType } from "./form-field-component";

export type FormComponentsByType = Map<DynamicFormType, { [id: string]: FormFieldComponentType }>;

export const DEFAULT_SUB_TYPE = "DEFAULT";

/**
 * Form types for form controls.
 */
export enum DynamicFormType {
  /**
   * Number form type
   */
  GROUP = "GROUP",

  /**
   * Array form type
   */
  ARRAY = "ARRAY",

  /**
   * Single form type
   */
  SINGLE = "SINGLE",

  /**
   * Hidden form type
   */
  HIDDEN = "HIDDEN"
}

export function isDynamicFieldType(value: any): value is DynamicFormType {
  return value in DynamicFormType;
}

export const DEFAULT_FORM_COMPONENTS = new InjectionToken<FormComponentsByType>("default form components");
